"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentStoreWithRevokeReasons__factory = void 0;
var _ethers = require("ethers");
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

class DocumentStoreWithRevokeReasons__factory extends _ethers.ContractFactory {
  constructor(signer) {
    super(_abi, _bytecode, signer);
  }
  deploy(_name, owner, overrides) {
    return super.deploy(_name, owner, overrides || {});
  }
  getDeployTransaction(_name, owner, overrides) {
    return super.getDeployTransaction(_name, owner, overrides || {});
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }
}
exports.DocumentStoreWithRevokeReasons__factory = DocumentStoreWithRevokeReasons__factory;
const _abi = [{
  inputs: [{
    internalType: "string",
    name: "_name",
    type: "string"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "DocumentIssued",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "DocumentRevoked",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "reason",
    type: "uint256"
  }],
  name: "DocumentRevokedWithReason",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint8",
    name: "version",
    type: "uint8"
  }],
  name: "Initialized",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "previousAdminRole",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "newAdminRole",
    type: "bytes32"
  }],
  name: "RoleAdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleRevoked",
  type: "event"
}, {
  inputs: [],
  name: "DEFAULT_ADMIN_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "ISSUER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "REVOKER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32[]",
    name: "documents",
    type: "bytes32[]"
  }],
  name: "bulkIssue",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32[]",
    name: "documents",
    type: "bytes32[]"
  }],
  name: "bulkRevoke",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32[]",
    name: "documents",
    type: "bytes32[]"
  }, {
    internalType: "uint256",
    name: "reason",
    type: "uint256"
  }],
  name: "bulkRevoke",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "documentIssued",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "documentRevoked",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "getIssuedBlock",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }],
  name: "getRoleAdmin",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "grantRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "hasRole",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "isIssued",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "blockNumber",
    type: "uint256"
  }],
  name: "isIssuedBefore",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "isRevoked",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "blockNumber",
    type: "uint256"
  }],
  name: "isRevokedBefore",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "issue",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "renounceRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "revoke",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "reason",
    type: "uint256"
  }],
  name: "revoke",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "revokeReason",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "revokeRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "version",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}];
const _bytecode = "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";